import {
  ADD_SECURITY_OFFICER_FAILURE,
  ADD_SECURITY_OFFICER_REQUEST,
  ADD_SECURITY_OFFICER_SUCCESS,
  DELETE_SECURITY_OFFICER_FAILURE,
  DELETE_SECURITY_OFFICER_REQUEST,
  DELETE_SECURITY_OFFICER_SUCCESS,
  FETCH_LIST_SECURITY_OFFICERS_FAILURE,
  FETCH_LIST_SECURITY_OFFICERS_REQUEST,
  FETCH_LIST_SECURITY_OFFICERS_SUCCESS,
  FETCH_SECURITY_OFFICER_FAILURE,
  FETCH_SECURITY_OFFICER_REQUEST,
  FETCH_SECURITY_OFFICER_SUCCESS,
  RESET_CURRENT_SECURITY_OFFICER,
  UPDATE_SECURITY_OFFICER_FAILURE,
  UPDATE_SECURITY_OFFICER_REQUEST,
  UPDATE_SECURITY_OFFICER_SUCCESS,
} from "./securityType";
export const fetchSecurityOfficers = (pageNo) => {
  console.log("pageNo", pageNo);
  return {
    type: FETCH_LIST_SECURITY_OFFICERS_REQUEST,
    payload: pageNo,
  };
};

export const fetchSecurityOfficersSuccess = (securityOfficers) => ({
  type: FETCH_LIST_SECURITY_OFFICERS_SUCCESS,
  payload: { securityOfficers },
});

export const fetchSecurityOfficersFailure = (error) => ({
  type: FETCH_LIST_SECURITY_OFFICERS_FAILURE,
  payload: { error },
});

// View single security officer
export const fetchSecurityOfficer = (securityOfficerId) => ({
  type: FETCH_SECURITY_OFFICER_REQUEST,
  payload: { securityOfficerId },
});

export const fetchSecurityOfficerSuccess = (securityOfficer) => ({
  type: FETCH_SECURITY_OFFICER_SUCCESS,
  payload: { securityOfficer },
});

export const fetchSecurityOfficerFailure = (error) => ({
  type: FETCH_SECURITY_OFFICER_FAILURE,
  payload: { error },
});

// Add security officer
export const addSecurityOfficer = (securityOfficerData) => ({
  type: ADD_SECURITY_OFFICER_REQUEST,
  payload: { securityOfficerData },
});

export const addSecurityOfficerSuccess = (securityOfficer) => ({
  type: ADD_SECURITY_OFFICER_SUCCESS,
  payload: { securityOfficer },
});

export const addSecurityOfficerFailure = (error) => ({
  type: ADD_SECURITY_OFFICER_FAILURE,
  payload: { error },
});

// Edit security officer
export const updateSecurityOfficer = (securityOfficerId, securityOfficerData) => ({
  type: UPDATE_SECURITY_OFFICER_REQUEST,
  payload: { securityOfficerId, securityOfficerData },
});

export const updateSecurityOfficerSuccess = (securityOfficer) => ({
  type: UPDATE_SECURITY_OFFICER_SUCCESS,
  payload: { securityOfficer },
});

export const updateSecurityOfficerFailure = (error) => ({
  type: UPDATE_SECURITY_OFFICER_FAILURE,
  payload: { error },
});

// Delete security officer
export const deleteSecurityOfficer = (securityOfficerId) => ({
  type: DELETE_SECURITY_OFFICER_REQUEST,
  payload: { securityOfficerId },
});

export const deleteSecurityOfficerSuccess = (securityOfficerId) => ({
  type: DELETE_SECURITY_OFFICER_SUCCESS,
  payload: { securityOfficerId },
});

export const deleteSecurityOfficerFailure = (error) => ({
  type: DELETE_SECURITY_OFFICER_FAILURE,
  payload: { error },
});

// Reset current security officer
export const resetCurrentSecurityOfficer = () => ({
  type: RESET_CURRENT_SECURITY_OFFICER,
});